import type { CategoryViewProps } from '../../types';
import * as React from 'react';
import { CollectionA as CollectionComponent } from '../../containers/CollectionA';

export function View(props: CategoryViewProps) {
  return (
    <>
      <CollectionComponent {...props} />
    </>
  );
}
